import React, { useContext } from "react";
import ThemeContext from "../contexts/ThemeContext";

const OrdersTable = ({
  orders = [], // Defaulting to empty array to avoid undefined errors
  showDeleteConfirm,
  deleteConfirm,
  hideDeleteConfirm,
  confirmDeleteOrder,
}) => {
  const { isDark } = useContext(ThemeContext);

  return (
    <>
      <div
        className={`card shadow-sm p-4 ${isDark ? 'border-secondary' : ''}`}
        style={isDark ? { backgroundColor: '#1e1e1e', borderColor: '#444' } : {}}
      >
        <h2 className={`h5 mb-3 ${isDark ? 'text-light' : ''}`}>Orders</h2>

        {orders.length === 0 ? (
          <p className={isDark ? 'text-light' : ''}>No orders yet.</p>
        ) : (
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table
              className={`table table-bordered align-middle ${isDark ? 'table-dark' : ''}`}
              style={{ minWidth: '900px' }}
            >
              <thead className="table-dark">
                <tr>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Address</th>
                  <th>Products</th>
                  <th>Total</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {orders.map((order) => (
                  <tr key={order._id}>
                    <td>{order.customerName}</td>
                    <td>{order.phone}</td>
                    <td>
                      {`${order.buildingNo || ""} ${order.street || ""} ${
                        order.city || ""
                      } - ${order.pinCode || ""}`}
                    </td>

                    <td>
                      <ul className="mb-0 ps-3">
                        {order.items?.map((i) => (
                          <li key={i.productId}>
                            {i.name} × {i.quantity}
                          </li>
                        ))}
                      </ul>
                    </td>

                    {/* FIX: Ensuring total amount is displayed even if it's 0 or null */}
                    <td className="fw-bold text-danger">
                      ₹{order.totalAmount != null ? order.totalAmount : 0}
                    </td>

                    <td>
                      {order.orderDate ? new Date(order.orderDate).toLocaleString() : "N/A"}
                    </td>

                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          showDeleteConfirm(order._id, order.customerName)
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal */}
      {deleteConfirm?.show && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  className="btn-close btn-close-white"
                  onClick={hideDeleteConfirm}
                />
              </div>

              <div className="modal-body">
                Delete order of <b>{deleteConfirm.orderName}</b>?
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={hideDeleteConfirm}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={confirmDeleteOrder}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrdersTable;